import React, { useState } from 'react';
import { EmptySong, RosalinaObservatory, Underground, SongOfStorms, GreatFairyFountain, SilverLining } from './songs.js';
import audioRosalinaObservatory from './SampleSongs/RosalinaObservatory.mp3';
import audioUnderground from './SampleSongs/Underground.mp3';
import audioSongOfStorms from './SampleSongs/SongOfStorms.mp3';
import audioGreatFairyFountain from './SampleSongs/GreatFairyFountain.mp3';
import audioSilverLining from './SampleSongs/SilverLining.mp3';
import './songs.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { FiPause } from 'react-icons/fi';
import { FcMusic } from 'react-icons/fc';

const song = new Audio();

function Score() {
  const [name, setName] = useState('');
  return (
    <>
    <Navbar bg="light" expand="lg">
      <Container>
        <Navbar.Brand style={{fontFamily: 'Courier'}} href="#home">KeyTone</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#home" onClick={() => song.pause()}><FiPause/></Nav.Link>
            <FcMusic style={{position: 'relative', marginTop: '15px', marginLeft: '15px'}}/>
            <NavDropdown title="" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1" onClick={() => {
                setName('RosalinaObservatory');
                song.src = audioRosalinaObservatory;
                song.volume = 0.5;
                song.play();
              }}>
                Rosalina's Observatory
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.2" onClick={() => {
                setName('SongOfStorms');
                song.src = audioSongOfStorms;
                song.volume = 0.5;
                song.play();
              }}>
                Song of Storms
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.1" onClick={() => {
                setName('SilverLining');
                song.src = audioSilverLining;
                song.volume = 0.5;
                song.play();
              }}>
                A Silver Lining
              </NavDropdown.Item>
              <NavDropdown.Divider/>
              <NavDropdown.Item href="#action/3.3" onClick={() => {
                setName('GreatFairyFountain');
                song.src = audioGreatFairyFountain;
                song.volume = 0.5;
                song.play();
              }}>The Great Fairy's Fountain</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4" onClick={() => {
                setName('Underground');
                song.src = audioUnderground;
                song.volume = 0.5;
                song.play();
              }}>
                The Underground
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    <Selection title={name}/>
    </>
  );
}
function Selection(props) {
  if (props.title === "RosalinaObservatory") return <RosalinaObservatory/>;
  if (props.title === "SongOfStorms") return <SongOfStorms/>;
  if (props.title === "SilverLining") return <SilverLining/>;
  if (props.title === "GreatFairyFountain") return <GreatFairyFountain/>;
  if (props.title === "Underground") return <Underground/>;
  return <EmptySong/>
}
export default Score